import React, { forwardRef } from "react";
import { Checkbox, Field as UIField, Label } from "@headlessui/react";
import { CheckIcon } from "@heroicons/react/16/solid";
import { Field } from "../../../configuration";
export type Checklist = Set<string>;

export interface CheckboxProps extends Field {
  value?: string;
  onChange: (newValue?: string) => void;
}

const CheckboxGroup = forwardRef(
  ({ name, options, value, onChange }: CheckboxProps, ref) => {
    const checklist = new Set(value?.split(","));

    const handleChange = (optionValue: string, checked: boolean) => {
      if (checked) {
        checklist.add(optionValue);
      } else {
        checklist.delete(optionValue);
      }
      const sortedChecklist =
        checklist.size > 0
          ? Array.from(checklist).sort((a, b) => {
              const indexA = options!.findIndex((option) => option.value === a);
              const indexB = options!.findIndex((option) => option.value === b);
              return indexA - indexB;
            })
          : undefined;
      onChange(sortedChecklist?.join(","));
    };

    return (
      <fieldset className="flex flex-col flex-wrap gap-4">
        {options?.map((option, i) => (
          <UIField key={`${name}-${i}`} className="flex items-center gap-3">
            <Checkbox
              name={name}
              value={option.value}
              checked={checklist.has(option.value)}
              onChange={(e) => handleChange(option.value, e)}
              className="group size-8 rounded bg-white/10 p-1 ring-2 ring-novartis-font ring-inset data-[checked]:bg-brand data-[checked]:ring-brand"
            >
              <CheckIcon className="hidden size-6 fill-novartis-font stroke-novartis-font group-data-[checked]:block group-data-[checked]:fill-white group-data-[checked]:stroke-white" />
            </Checkbox>
            <Label className="text-novartis-font">{option.label}</Label>
          </UIField>
        ))}
      </fieldset>
    );
  }
);

export default CheckboxGroup;
